<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" sm="12">
        <AppSectionHero :section-number="sectionNumber">
          <template v-slot:main-title>{{
            $t("content.sections.what.title.lead")
          }}</template>
          <template v-slot:title>{{
            $t("content.sections.what.title.body")
          }}</template>
        </AppSectionHero>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="6">
        <!-- <p class="pt-3">{{ $t("content.sections.what.intro") }}</p> -->

        <AppDashboardSection>
          <template v-slot:intro>
            <div class="pb-5">
              <AppChartLegend
                :items="[
                  {
                    label: $t(
                      'content.sections.what.subsections.experienced.title'
                    ),
                    color: '#194173',
                    shape: 'circle'
                  }
                ]"
                :title="true"
              />

              <div class="body-2">
                {{ $t("content.sections.what.subsections.experienced.intro") }}
              </div>
            </div>
            <div>
              <AppChartLegend
                :items="[
                  {
                    label: $t('content.sections.what.subsections.severe.title'),
                    color: '#EB2227',
                    shape: 'circle'
                  }
                ]"
                :title="true"
              />
              <div class="body-2">
                {{ $t("content.sections.what.subsections.severe.intro") }}
              </div>
              <!-- Sort by -->
              <div class="d-flex pt-5">
                <div class="mr-3 body-2">{{ $t("interface.sortBy") }}</div>
                <v-radio-group
                  v-model="primaryKey"
                  row
                  class="mt-0 pt-0"
                  hide-details
                >
                  <v-radio
                    :label="$t('legalProblemLegend.prevalence')"
                    value="prevalence"
                    color="#194173"
                    hide-details
                  ></v-radio>
                  <v-radio
                    :label="$t('legalProblemLegend.severity')"
                    value="severity"
                    color="#EB2227"
                    hide-details
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
          </template>
          <template v-slot:main>
            <DumbbellChartLegalProblem :primary-key="primaryKey" />
          </template>
        </AppDashboardSection>
      </v-col>
      <v-col cols="12" lg="6">
        <AppDashboardSection>
          <template v-slot:intro
            ><h3>
              {{ $t("content.sections.what.subsections.impactIndex.title") }}
            </h3>
            <div class="body-2">
              {{ $t("content.sections.what.subsections.impactIndex.intro") }}
            </div>
          </template>
          <template v-slot:main>
            <ImpactIndexChart :section-number="sectionNumber" class="pb-10" />
          </template>
        </AppDashboardSection>
        <AppTableHidden
          :table-headers="tableHeaders"
          :table-data="tableData"
          sorted-column="experiencedCount"
          :section-number="sectionNumber"
        >
          <template v-slot:table-title>{{
            $t("content.sections.what.infoTable.title")
          }}</template>
          <template v-slot:card-info>
            <i18n tag="div" path="content.sections.what.infoTable.infoText">
              <span
                slot="ProblemExperienced"
                class="section2--text font-weight-black"
                >{{
                  $t("content.sections.what.infoTable.problemExperienced")
                }}</span
              >
            </i18n>
          </template>
        </AppTableHidden>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AppBorderedSection from "@/components/AppBorderedSection.vue";
import AppSectionHero from "@/components/AppSectionHero.vue";
import AppDashboardSection from "@/components/AppDashboardSection.vue";
import DumbbellChartLegalProblem from "@/components/DumbbellChartLegalProblem.vue";
import AppTableHidden from "@/components/AppTableHidden.vue";
import lpToCategory from "@/assets/problemToCategoryMapper.json";
import ImpactIndexChart from "@/components/ImpactIndexChart.vue";
import AppChartLegend from "@/components/AppChartLegend.vue";

export default {
  components: {
    AppBorderedSection,
    AppDashboardSection,
    DumbbellChartLegalProblem,
    AppSectionHero,
    AppTableHidden,
    ImpactIndexChart,
    AppChartLegend
  },
  props: {
    sectionNumber: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      primaryKey: "prevalence",
      tableHeaders: [
        {
          text: this.$t("content.sections.what.infoTable.columnLegalProblem"),
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Problem category", value: "problemCategory" },
        {
          text: this.$t(
            "content.sections.what.infoTable.columnExperiencedNumber"
          ),
          value: "experiencedCount",
          width: "75px"
        },
        {
          text: this.$t(
            "content.sections.what.infoTable.columnExperiencedPercent"
          ),
          value: "percentPeopleExperienced",
          width: "115px"
        },
        {
          text: this.$t("content.sections.what.infoTable.columnSevereNumber"),
          value: "severeCount",
          width: "75px"
        },
        {
          text: this.$t("content.sections.what.infoTable.columnSeverePercent"),
          value: "percentPeopleSevere",
          width: "115px"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["filteredCount", "filteredSubLegalProblemsData"]),
    tableData() {
      const formattedSubLegalProblems = [];
      this.filteredSubLegalProblemsData().forEach(d => {
        if (d.experiencedCount != 0) {
          formattedSubLegalProblems.push({
            key: d.key,
            name: this.$t(`specificLegalProblems.${d.key}`),
            problemCategory: this.$t(
              `filters.legalProblems.legalProblem.options.${
                lpToCategory[d.key]
              }`
            ),
            experiencedCount: d.experiencedCount,
            percentPeopleExperienced: d.percentPeopleExperience,
            severeCount: d.severeCount,
            percentPeopleSevere: d.percentPeopleSevere
          });
        }
      });
      return formattedSubLegalProblems;
    }
  }
};
</script>